<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent>
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-check" v-show="btnSaveVisible" @click="save">
              환입저장
            </el-button>
            <el-button type="danger" icon="el-icon-check"  v-show="btnCancelVisible" @click="cancel">
              환입취소
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="환입기간" label-width="100px">
                <el-row>
                  <el-col>
                    <el-col :span="11">
                      <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: start;">-</el-col>
                    <el-col :span="12">
                      <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="환입상태" label-width="100px">
                <el-select v-model="form.procYn" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['procYn']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="환입구분" label-width="100px">
                <el-select v-model="form.asClass" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['asClass']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10" style="">
              <el-row>
                <el-form-item label="지역/센터" label-width="100px">
                  <el-col :span="10">
                    <el-select v-model="form.catId" @change="onCatIdChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['catId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="14">
                    <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subCatId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-form-item label="제조사" label-width="100px">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8" style="margin-left:0px;">
              <el-row>
                <el-form-item label="제품군" label-width="100px">
                  <el-col :span="10">
                    <el-select v-model="form.modelGroup" @change="onModelGroupChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['modelGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="14">
                    <el-select v-model="form.subModelGroup" v-show="changeModelGroupShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subModelGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="대표모델" label-width="100px">
                <el-input type="text" v-model="form.standardModelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="모델명" label-width="100px">
                <el-input type="text" v-model="form.modelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    
    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @grid-ready="onReadyMain" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";

import mixin from "@/mixin/lucoms";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  mixins: [mixin],
  data() {
    return {
      data: [],
      result: [],
      form: {
        companyId : '',
        startDt: this.$moment().format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        procYn : 'N',            // 환입상태
        asClass : '',            // 환입구분
        catId : '',              // 지역
        subCatId: '',            // 지역 상세
        maker : '',              // 제조사
        modelGroup : '',         // 제품군
        subModelGroup : '',      // 제품상세
        standardModelNm : '',    // 대표모델
        modelNm : '',            // 모델명
        sortType : '',
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      },
      combos: {
        'procYn' : [],           //환입상태
        'asClass' : [],          //환입구분
        'catId' : [],            //지역센터
        'subCatId' : [],         //sub지역센터
        'maker' : [],            //제조사
        'modelGroup' : [],       //제품군
        'subModelGroup' : [],    //sub제품군
        'outType' : [],
      },
      changeCatIdShow : false,
      changeModelGroupShow : false,
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 45px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      btnSaveVisible : false,
      btnCancelVisible : false
    }
  },
  methods: {
    async onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      await this.init().finally( _ => {
        setTimeout( _ => {
          this.goOpen();
        }, 1000 );
      });
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {
          headerName: '선택',
          field: 'chk',
          width: 80,
          cellRenderer: 'checkBox',
          cellRendererParams: {
              trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
            , disable: false
          },
        },
        {headerName:'환입일자', field:'modelReturnInDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'환입번호', field:'asId', width:170, cellStyle:{textAlign: 'center'}},
        {headerName:'환입구분', field:'changeAsClassCd', cellStyle:{textAlign: 'center'}, width:110},
        {headerName:'환입상태', field:'procYn', cellStyle:{textAlign: 'center'}, width:110},
        {headerName:'센터명', field:'repairAsAgentNm', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'제조사', field:'makerNm', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'modelGroupNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'대표모델', field:'standardModelNm', width:170},
        {headerName:'모델명', field:'modelNm', width:170},
        {headerName:'AS완료일자', field:'procDt', width:130, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
      ];
    },
    goOpen() {
      let that = this
      const vForm = {
        companyId :this.form.companyId,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        procYn : this.form. procYn,                      // 환입상태
        asClass : this.form.asClass,                     // 환입구분
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        subCatId: this.form.subCatId,                    // 지역 상세
        maker : this.form.maker,                         // 제조사
        modelGroup : (this.form.subModelGroup.length <= 0 || this.form.subModelGroup === '')  ? this.form.modelGroup : this.form.subModelGroup,          // 제품군
        subModelGroup : this.form.subModelGroup,         // 제품상세
        standardModelNm : this.form.standardModelNm,     // 대표모델
        modelNm : this.form.modelNm,                     // 모델명
        sortType : this.form.sortType,
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }
      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/productReEntering/list"), vForm)
          .then(response => {
            that.data = response.data
            /* data customize */
            this.changeData();
          })
          .finally(() => {
            this.btnSaveChk();
            this.btnCancelChk();
            this.$store.commit('finish')
          });
    },
    save() {
      let vm = this;
      let list = this.data.filter(v => v.chk)
      vm.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 환입저장을 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            vm.result = list;
            this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'Program.Page.ProductReEntering.ProductReEnteringApproval'}})
                .then(response => {
                  for(let i=0; i<vm.result.length; i++){
                    Object.assign(vm.result[i], { type: response.data[0].configValue });
                  }
                  this.$http.post(_url(`/api/workMng/productReEntering/save`), vm.result)
                      .then((response) => {
                        this.$swal({ type: 'success', text: '환입 저장을 했습니다.' })
                            .then((result) => {
                              if (result.value) this.goOpen();
                            });
                      }).catch((e) => {
                    this.$swal({ type: 'success', text: '환입 저장을 실패 했습니다.' })
                      }).finally(() => {
                        this.$store.commit('finish')
                      });
                })
          }
        })
      } else {
        this.$swal({ type: 'info', text: '저장할 항목을 선택하세요.' });
      }
    },
    cancel() {
      let vm = this;
      let list = this.data.filter(v => v.chk)
      this.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 환입취소를 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            vm.result = list;
            this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'Program.Page.ProductReEntering.ProductReEnteringCancel'}})
                .then(response => {
                  for (let i = 0; i < vm.result.length; i++) {
                    Object.assign(vm.result[i], {type: response.data[0].configValue});
                  }
                  this.$http.post(`/api/workMng/productReEntering/cancel`, vm.result)
                      .then((response) => {
                        this.$swal({ type: 'success', text: '환입 취소를 했습니다.' })
                            .then((result) => {
                              if (result.value) vm.goOpen();
                            });
                      }).catch((e) => {
                        this.$swal({ type: 'success', text: '환입 취소를 실패 했습니다.' })
                      }).finally(() => {
                        this.$store.commit('finish')
                      });
                })
          }
        })
      } else {
        this.$swal({ type: 'info', text: '취소할 항목을 선택하세요.' });
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/productReEntering/init`)
          .then(response => {
            this.combos['procYn'] = response.data.procYn;        //환입상태
            this.combos['asClass'] = response.data.asClass;      //환입구분
            this.combos['catId'] = response.data.catId;          //지역센터
            this.combos['maker'] = response.data.maker;          //제조사
            this.combos['modelGroup'] = response.data.modelGroup;  //제품군
            this.combos['outType'] = response.data.outType;
          }).finally(() => {
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false
      else{
        this.changeCatIdShow =  true
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    onModelGroupChange(param){
      this.form.subModelGroup = '';
      if(param === '') this.changeModelGroupShow =  false;
      else{
        this.changeModelGroupShow =  true
        // 제품군
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subModelGroup'] = response.data || []
                  });
            });
      }
    },
    btnSaveChk(){
      if(this.form.procYn === 'N'){
        this.btnSaveVisible = true;
        this.btnCancelVisible = false;
      } else if (this.form.procYn === 'Y'){
        this.btnSaveVisible = false;
        this.btnCancelVisible = true;
      } else {
        this.btnSaveVisible = false;
        this.btnCancelVisible = false;
      }
    },
    btnCancelChk(){
      if(this.form.procYn === 'Y'){
        this.btnCancelVisible = true;
        this.btnSaveVisible = false;
      } else if(this.form.procYn === 'N'){
        this.btnCancelVisible = false;
        this.btnSaveVisible = true;
      } else {
        this.btnSaveVisible = false;
        this.btnCancelVisible = false;
      }
    },
    /* data customize */
    changeData(){
      this.data.map((x, i) => {
        let filterProcYn = this.combos['procYn'].filter(y => y.key === x.procYn);
        x.procYn = filterProcYn[0].value;
        let filterAsClass = this.combos['asClass'].filter(y => y.key === x.changeAsClassCd);
        x.changeAsClassCd = filterAsClass[0].value;
      })
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>